var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 19.5C10.25 20.6046 11.1454 21.5 12.25 21.5C13.3546 21.5 14.25 20.6046 14.25 19.5C14.25 18.3954 13.3546 17.5 12.25 17.5C11.1454 17.5 10.25 18.3954 10.25 19.5ZM10.25 12.5C10.25 13.6046 11.1454 14.5 12.25 14.5C13.3546 14.5 14.25 13.6046 14.25 12.5C14.25 11.3954 13.3546 10.5 12.25 10.5C11.1454 10.5 10.25 11.3954 10.25 12.5ZM12.25 7.5C11.1454 7.5 10.25 6.60457 10.25 5.5C10.25 4.39543 11.1454 3.5 12.25 3.5C13.3546 3.5 14.25 4.39543 14.25 5.5C14.25 6.60457 13.3546 7.5 12.25 7.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots_vertical.c00c83e4fff6f6c080b69bb75323b3ab.svg";
export { ForwardRef as ReactComponent };